import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Doctor List
  doctorList: [],

  doctorListLoading: false,
  doctorDetails: null,
  doctorDetailsLoading: false,
  doctorPaginationData: {},

  // Doctor Specification
  doctorSpecificationList: [],
  doctorSpecificationLoading: false,
  doctorSpecificationPagination: {},

  updateDoctor: false,
  updateDoctorSpecificationList: false,
  modalOpen: false,
  ApiError: null,
}

const healthcareSlice = createSlice({
  name: 'healthcare',
  initialState,
  reducers: {
    // -------- Doctor List --------
    getDoctorListApiData: (state) => {
      state.doctorListLoading = true
    },
    getDoctorListApiSuccess: (state, { payload }) => {
      state.doctorListLoading = false
      state.doctorList = payload.data
      state.doctorPaginationData = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getDoctorListApiFailed: (state, { payload }) => {
      state.doctorListLoading = false
      state.ApiError = payload
    },

    doctorStatusChangeApiData: (state) => {
      state.doctorListLoading = true
      state.updateDoctor = false
    },
    doctorStatusChangeApiSuccess: (state, { payload }) => {
      state.doctorListLoading = false
      state.updateDoctor = true
      state.modalOpen = true
      state.ApiError = payload
    },
    doctorStatusChangeApiFailed: (state, { payload }) => {
      state.doctorListLoading = false
      state.ApiError = payload
    },

    // -------- Doctor Details --------
    getDoctorDetailsApiData: (state) => {
      state.doctorDetailsLoading = true
      state.doctorDetails = null
    },
    getDoctorDetailsApiSuccess: (state, { payload }) => {
      state.doctorDetailsLoading = false
      state.doctorDetails = payload.data
    },
    getDoctorDetailsApiFailed: (state, { payload }) => {
      state.doctorDetailsLoading = false
      state.ApiError = payload
    },

    // -------- Doctor Specification --------
    getDoctorSpecificationListApiData: (state) => {
      state.doctorSpecificationLoading = true
    },
    getDoctorSpecificationListApiSuccess: (state, { payload }) => {
      state.doctorSpecificationLoading = false
      state.doctorSpecificationList = payload.data
      state.doctorSpecificationPagination = {
        rowCount: payload?.total,
        page: payload?.page,
        size: payload?.size,
        nextPage: payload?.next_page,
        previousPage: payload?.previous_page,
      }
    },
    getDoctorSpecificationListApiFailed: (state, { payload }) => {
      state.doctorSpecificationLoading = false
      state.ApiError = payload
    },

    addDoctorSpecificationApiData: (state) => {
      state.updateDoctor = false
      state.modalOpen = false
    },
    addDoctorSpecificationApiSuccess: (state, { payload }) => {
      state.updateDoctorSpecificationList = true
      state.modalOpen = true
      state.ApiError = payload
    },
    addDoctorSpecificationApiFailed: (state, { payload }) => {
      state.ApiError = payload
    },

    updateDoctorSpecificationApiData: (state) => {
      state.updateDoctorSpecificationList = false
    },
    updateDoctorSpecificationApiSuccess: (state, { payload }) => {
      state.updateDoctorSpecificationList = true
      state.modalOpen = true
      state.ApiError = payload
    },
    updateDoctorSpecificationApiFailed: (state, { payload }) => {
      state.ApiError = payload
    },

    doctorSpecificationStatusChangeApiData: (state) => {
      state.doctorSpecificationLoading = true
      state.updateDoctorSpecificationList = false
    },
    doctorSpecificationStatusChangeApiSuccess: (state, { payload }) => {
      state.doctorSpecificationLoading = false
      state.updateDoctorSpecificationList = true
      state.modalOpen = true
      state.ApiError = payload
    },
    doctorSpecificationStatusChangeApiFailed: (state, { payload }) => {
      state.doctorSpecificationLoading = false
      state.ApiError = payload
      state.updateDoctorSpecificationList = false
    },

    // Reset
    resetHealthcareError: (state) => {
      state.ApiError = null
      state.modalOpen = false
    },
  },
})

export const {
  // Doctor List
  getDoctorListApiData,
  getDoctorListApiSuccess,
  getDoctorListApiFailed,
  doctorStatusChangeApiData,
  doctorStatusChangeApiSuccess,
  doctorStatusChangeApiFailed,

  getDoctorDetailsApiData,
  getDoctorDetailsApiSuccess,
  getDoctorDetailsApiFailed,

  // Doctor Specification
  getDoctorSpecificationListApiData,
  getDoctorSpecificationListApiSuccess,
  getDoctorSpecificationListApiFailed,
  addDoctorSpecificationApiData,
  addDoctorSpecificationApiSuccess,
  addDoctorSpecificationApiFailed,
  updateDoctorSpecificationApiData,
  updateDoctorSpecificationApiSuccess,
  updateDoctorSpecificationApiFailed,
  doctorSpecificationStatusChangeApiData,
  doctorSpecificationStatusChangeApiSuccess,
  doctorSpecificationStatusChangeApiFailed,

  resetHealthcareError,
} = healthcareSlice.actions

export default healthcareSlice.reducer
